export default __webpack_public_path__ + "static/media/donate.873268b9.svg";